import { InfoCircle } from "@untitledui/icons";
import type { ComponentType } from "react";
import { Tooltip, TooltipTrigger } from "@/components/base/tooltip/tooltip";
import { cx } from "@/utils/cx";

type StatTileProps = {
  value: string;
  label: string;
  layout?: "value-first" | "label-first";
  showInfoIcon?: boolean;
  tooltipText?: string;
  subtext?: string;
  subtextTone?: "success" | "neutral";
  subtextIcon?: ComponentType<{ className?: string }>;
};

export const StatTile = ({
  value,
  label,
  layout = "value-first",
  showInfoIcon = false,
  tooltipText = "Info",
  subtext,
  subtextTone = "neutral",
  subtextIcon: SubtextIcon,
}: StatTileProps) => {
  const valueBlock = (
    <p className="text-2xl leading-8 font-medium text-primary w-full">
      {value}
      {subtext && (
        <span
          className={cx(
            "flex items-center gap-1 text-xs font-medium",
            subtextTone === "success" ? "text-success-600" : "text-tertiary",
          )}
        >
          {SubtextIcon && <SubtextIcon className="size-3 shrink-0" />}
          {subtext}
        </span>
      )}
    </p>
  );

  if (layout === "label-first") {
    return (
      <div className="flex flex-col justify-between self-stretch w-full bg-white rounded-xl p-5 gap-3">
        <div className="flex items-start justify-between w-full">
          <p className="text-sm font-medium text-tertiary flex-1">{label}</p>
          {showInfoIcon && (
            <Tooltip title={tooltipText}>
              <TooltipTrigger className="inline">
                <InfoCircle className="size-5 text-quaternary shrink-0" />
              </TooltipTrigger>
            </Tooltip>
          )}
        </div>
        {valueBlock}
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3 w-full bg-white rounded-xl p-5">
      {valueBlock}
      <p className="text-xs text-tertiary">{label}</p>
    </div>
  );
};
